import { render, staticRenderFns } from "./SidebarNav.vue?vue&type=template&id=12eb2358&scoped=true&"
import script from "./SidebarNav.vue?vue&type=script&lang=js&"
export * from "./SidebarNav.vue?vue&type=script&lang=js&"
import style0 from "./SidebarNav.vue?vue&type=style&index=0&id=12eb2358&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12eb2358",
  null
  
)

export default component.exports